export { default as i18nRouting } from './i18n.config'
